import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addToCart } from "../redux/slices/cartSlice";
import styled from "styled-components";
import { FiBookOpen } from "react-icons/fi";
import { Colors } from "../utils/colors";
import { Sizes } from "../utils/sizes";

const Wrap = styled.section`
  width: 100%;
  background: #111;
  padding: 80px 0;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(255,215,0,0.25), transparent);
  }
`;

const Inner = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  align-items: center;
  gap: 60px;

  @media (max-width: ${Sizes.mediaQueryBreak1}) {
    gap: 40px;
  }

  @media (max-width: ${Sizes.mediaQueryBreak2}) {
    flex-direction: column-reverse;
    gap: 36px;
    text-align: center;
    align-items: center;
  }
`;

const ImgSide = styled.div`
  flex-shrink: 0;
  width: 38%;

  @media (max-width: ${Sizes.mediaQueryBreak1}) {
    width: 46%;
  }

  @media (max-width: ${Sizes.mediaQueryBreak2}) {
    width: 80%;
    max-width: 380px;
  }

  @media (max-width: ${Sizes.mediaQueryBreak3}) {
    width: 100%;
    max-width: 300px;
  }

  img {
    width: 100%;
    border-radius: 12px;
    cursor: pointer;
    transition: transform 0.2s;
    box-shadow: 0 24px 70px rgba(0,0,0,0.55);

    &:hover { transform: scale(1.02); }
  }
`;

const TextSide = styled.div`
  flex: 1;
`;

const Label = styled.p`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: ${Colors.yellow};
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin: 0 0 14px;
`;

const Title = styled.h2`
  color: #fff;
  font-size: clamp(1.8rem, 3.5vw, 2.6rem);
  font-weight: 800;
  line-height: 1.2;
  margin: 0 0 18px;

  span { color: ${Colors.yellow}; }
`;

const Body = styled.p`
  color: rgba(255,255,255,0.65);
  font-size: 1rem;
  line-height: 1.7;
  margin: 0 0 32px;
`;

const Features = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 36px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (max-width: ${Sizes.mediaQueryBreak2}) {
    align-items: center;
    text-align: left;
  }

  li {
    display: flex;
    align-items: center;
    gap: 10px;
    color: rgba(255,255,255,0.85);
    font-size: 0.95rem;

    &::before {
      content: '✓';
      color: ${Colors.yellow};
      font-weight: 800;
      flex-shrink: 0;
    }
  }
`;

const Cta = styled.button`
  background: ${Colors.yellow};
  color: #0a0a0a;
  border: none;
  padding: 16px 40px;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 800;
  cursor: pointer;
  transition: transform 0.15s, box-shadow 0.15s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(255,215,0,0.3);
  }
`;

const PriceAnchor = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;

  .original {
    color: rgba(255,255,255,0.5);
    font-size: 0.95rem;
    text-decoration: line-through;
  }

  .discount {
    background: rgba(255,215,0,0.12);
    color: ${Colors.yellow};
    font-size: 11px;
    font-weight: 800;
    padding: 3px 10px;
    border-radius: 20px;
  }
`;

const Section = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleComprar = () => {
    dispatch(addToCart({
      id: 'colecao-completa-13-1',
      title: 'COLEÇÃO COMPLETA: 13 EM 1',
      price: 7990,
      category: 'Coleções',
    }));
    navigate('/checkout');
  };

  return (
    <Wrap>
      <Inner>
        <ImgSide>
          <img
            src="/capaEbooksLoja/colecaocompleta.png"
            alt="Coleção Completa 13 em 1"
            onClick={handleComprar}
          />
        </ImgSide>
        <TextSide>
          <Label><FiBookOpen size={13} /> Coleção Completa</Label>
          <Title>
            13 e-books para elevar o<br />
            <span>nível do seu ministério</span>
          </Title>
          <Body>
            Tudo que você precisa para tocar com mais precisão e segurança na
            celebração litúrgica — cifras organizadas, corretas e fáceis de usar.
          </Body>
          <Features>
            <li>+500 cifras de todos os tempos litúrgicos</li>
            <li>Cifras simplificadas sobre a letra</li>
            <li>Indicação rítmica em cada música</li>
            <li>Dicionário de acordes incluso</li>
            <li>Músicas sem pestana para iniciantes</li>
            <li>Videoaulas para todas as músicas no YouTube</li>
          </Features>
          <PriceAnchor>
            <span className="original">De R$ 149,90</span>
            <span className="discount">47% OFF</span>
          </PriceAnchor>
          <Cta onClick={handleComprar}>
            COMPRAR COLEÇÃO — R$ 79,90
          </Cta>
        </TextSide>
      </Inner>
    </Wrap>
  );
};

export default Section;
